import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Badge } from '../Badge/Badge'

export const FilterTypeMenu = ({ label, items, className, callback }) => {
  // const ref = useRef(null)

  const containerClasses = classNames(className, {

  })

  function onClick (i) {
    callback(i)
  }

  return (
    <div className={containerClasses}>

      {label && <span className='tag-filter-label m-thin-right'>{label}</span>}

      {items.map((item, i) =>
        (
          <Badge {...item} onClick={() => onClick(i)} />
        ))}

    </div>
  )
}

FilterTypeMenu.defaultProps = {

}

FilterTypeMenu.propTypes = {
  label: PropTypes.string,
  items: PropTypes.Array,
  className: PropTypes.string,
  callback: PropTypes.func
}
